// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading-page[data-v-51214d7c]{position:fixed;top:0;left:0;width:100%;height:100%;background:#4d0d90;background:linear-gradient(180deg,#4d0d90 -15%,#02021e 7%,#070326 80%,#5b0fa4 150%);z-index:9999}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
